"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SvgWalletOutlined = function SvgWalletOutlined(_ref) {
  var fill = _ref.fill,
      theme = _ref.theme,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "theme", "title"]);

  return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), {}, {
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.587 10.518v-1.93a3.064 3.064 0 00-3.066-3.065H3.594c-.644 0-1.17-.54-1.144-1.207.024-.623.576-1.099 1.2-1.099h11.87c.438 0 .82.25 1.013.619a.97.97 0 00.862.531.966.966 0 00.85-1.414 3.065 3.065 0 00-2.724-1.657H3.594A3.067 3.067 0 00.528 4.363V15.904a3.065 3.065 0 003.066 3.067h11.927a3.065 3.065 0 003.066-3.067v-1.929h-1.922v1.929c0 .63-.514 1.145-1.144 1.145H3.594c-.63 0-1.145-.515-1.145-1.145V7.22c.354.142.74.223 1.145.223h11.927c.63 0 1.144.515 1.144 1.145v1.928h1.922z",
      fill: fill || theme.colors.primary.main
    }), (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.48 9.365h-4.319a2.259 2.259 0 00-2.259 2.259v1.245a2.259 2.259 0 002.259 2.259h4.32a2.259 2.259 0 002.258-2.259v-1.245a2.259 2.259 0 00-2.259-2.259z",
      fill: fill || theme.colors.primary.main
    }), (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.48 10.857c.424 0 .767.343.767.767v1.245a.768.768 0 01-.767.767h-4.32a.768.768 0 01-.766-.767v-1.245c0-.424.344-.767.767-.767h4.32z",
      fill: "#fff"
    })]
  }));
};

var _default = SvgWalletOutlined;
exports["default"] = _default;